import React from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Hamburger from 'hamburger-react'
// import handleCart from '../redux/reducer/handleCart'

const Nevbar = () => {
  const state = useSelector((state) => state.handleCart)
  console.log(state)
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light bg-white py-3 shadow-sm">
        <div className="container">
          <NavLink className="navbar-brand fw-bold fs-4" to="/">
            KRT COLLECTION
          </NavLink>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <Hamburger
              direction="right"
              size={30}
              color="gray"
              duration={0.2}
            ></Hamburger>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink className="nav-link active" aria-current="page" to="/">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/products">
                  Product
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/about">
                  About Us
                </NavLink>
              </li>{' '}
              <li className="nav-item">
                <NavLink className="nav-link" to="/contact">
                  Contact
                </NavLink>
              </li>
            </ul>
            <div className="buttons"></div>
            <NavLink to="/Login" className="btn btn-outline-dark">
              <i className="fa fa-sign-in me-1"></i>Login
            </NavLink>
            <div className="buttons"></div>
            <NavLink to="/Register" className="btn btn-outline-dark ms-2">
              <i className="fa fa-user-plus me-1"></i>Register
            </NavLink>
            <div className="buttons"></div>
            {/* <NavLink to="/cart" className="btn btn-outline-dark ms-2">
           <i className="fa fa-shopping-cart me-1"></i>Cart ({state.length})</NavLink> */}
            <NavLink to="/cart" className="btn btn-outline-dark ms-2">
              <i className="fa fa-shopping-cart me-1"></i>Cart ({state.length})
            </NavLink>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Nevbar
